module.exports = __webpack_public_path__ + "static/img/lb6.5d6374d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb6.png
// module id = bDx/
// module chunks = 0